export const LIST_STYLE_OPTIONS = [
  { value: 'none', label: 'なし' },
  { value: 'disc', label: '黒丸' },
  { value: 'circle', label: '白丸' },
  { value: 'square', label: '四角' },
  { value: 'decimal', label: '数字' },
  { value: 'upper-alpha', label: '大文字アルファベット' },
  { value: 'lower-alpha', label: '小文字アルファベット' },
  { value: 'upper-roman', label: '大文字ローマ数字' },
  { value: 'lower-roman', label: '小文字ローマ数字' },
  { value: 'decimal-leading-zero', label: '2桁の数字' },
  { value: 'lower-greek', label: '小文字ギリシャ文字' },
  { value: 'upper-latin', label: '大文字ラテン文字' },
  { value: 'lower-latin', label: '小文字ラテン文字' },
  { value: 'hebrew', label: 'ヘブライ数字' },
  { value: 'armenian', label: 'アルメニア数字' },
  { value: 'georgian', label: 'グルジア数字' },
  { value: 'cjk-ideographic', label: '漢数字' },
  { value: 'hiragana', label: 'ひらがな' },
  { value: 'katakana', label: 'カタカナ' },
  { value: 'hiragana-iroha', label: 'いろは' },
  { value: 'katakana-iroha', label: 'イロハ' }
];

export const isUlorOl = (listStyleTypeValue)=>{
  return [
    'none',
    'disc',
    'circle',
    'square',
  ].includes(listStyleTypeValue)?'ul':"ol"
}